module.exports = __webpack_public_path__ + "static/media/saturn.429a37bc.png";